import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'
import { useBuildSortingParams } from '../../../lib/hooks/useBuildSortingParams'
import { useQuery, UseQueryResult } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

type ResultType = {
  creatives?: any
  link_campaign_id: number
  vendor_campaign_name?: string
  campaign_display_name?: string
  pacing_id: number
  objective?: string
  start_date?: string
  end_date?: string
  budget?: string
  zip?: string
  product_code: string
  notes?: string
  allowed_vehicle_states?: string
  allowed_makes?: string
  disallowed_makes?: string
  allowed_models?: string
  disallowed_models?: string
  allowed_body_substrings?: string
  disallowed_body_substrings?: string
  earliest_allowed_year?: string
  latest_allowed_year?: string
  lowest_allowed_price?: string
  highest_allowed_price?: string
  lowest_allowed_mileage?: string
  highest_allowed_mileage?: string
  allowed_stock_number_prefixes?: string
  disallowed_stock_number_prefixes?: string
  minimum_age_days?: string
  maximum_age_days?: string
  allowed_locations?: string
  disallowed_locations?: string
  no_price_only?: boolean
  exclude_if_no_price?: boolean
}

export const useGetIncompleteCampaignsByDealershipId = ({
  pageIndex,
  pageSize,
  filters,
  sorting,
}: {
  pageIndex?: number
  pageSize?: number
  filters?: Record<string, unknown>
  sorting?: Array<Record<string, unknown>>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()

  const queryParams = useBuildQueryParams(filters)
  const sortingParams = useBuildSortingParams(sorting)
  return useQuery<ResultType, Error>(
    [
      'dealership',
      dealership?.id,
      'campaigns',
      'incomplete',
      { pageIndex, pageSize, queryParams, sortingParams },
    ],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/incomplete`,
        method: 'GET',
        params: {
          pageIndex: pageIndex,
          pageSize,
          ...queryParams,
          sorting: sortingParams,
        },
        signal,
      }),
    {
      enabled: !!dealership?.id,
      keepPreviousData: false,
      cacheTime: 0,
    },
  )
}
